exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2sEXgpXrlJsstNjvCPJ99B{font-size:12px;font-weight:400;height:24px;color:\"[theme:themeDarkAlt, default:#005A9E]\"}html[dir] ._2sEXgpXrlJsstNjvCPJ99B{border-radius:4px;padding:0}._2sEXgpXrlJsstNjvCPJ99B:active,._2sEXgpXrlJsstNjvCPJ99B:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}.CZUtwpe17Ex7qHWfgZ9LP{font-size:12px;font-weight:400}html[dir] .CZUtwpe17Ex7qHWfgZ9LP{margin:1px 0 0}", ""]);

// exports
exports.locals = {
	"viewEmailButton": "_2sEXgpXrlJsstNjvCPJ99B",
	"emailIcon": "CZUtwpe17Ex7qHWfgZ9LP"
};